import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import Services from './pages/Services';
import DataAnalyticAndConsulting from './pages/DataAnalyticAndConsulting';
import BusinessIntelligence from './pages/BusinessIntelligence';
import AIMachineLearning from './pages/AIMachineLearning';
import KPIDashboarding from './pages/KPIDashboarding';
import ProjectManagement from './pages/ProjectManagement';
import WebsiteDevelopment from './pages/WebsiteDevelopment';
import Contact from './components/Contact';
import ScrollToHash from './components/ScrollToHash';
import Navbar from './components/Navbar';
import About from './pages/About';

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <ScrollToHash />
        <Routes>
          <Route path="" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/data-analytics" element={<DataAnalyticAndConsulting />} />
          <Route path="/services/business-intelligence" element={<BusinessIntelligence />} />
          <Route path="/services/ai-and-ml" element={<AIMachineLearning />} />
          <Route path="/services/kpi-dashboarding" element={<KPIDashboarding />} />
          <Route path="/services/project-management" element={<ProjectManagement />} />
          <Route path="/services/website-development" element={<WebsiteDevelopment />} />
          {/* <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/user" element={<UserPage />} /> */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
